import axios from "axios";

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

const createApiClient = () => {
  const token = localStorage.getItem("authToken");
  return axios.create({
    baseURL: API_BASE_URL,
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
      "Content-Type": "application/json",
    },
  });
};

export const getAdminDashboardSummary = async () => {
  const apiClient = createApiClient();
  const response = await apiClient.get("/api/admin/dashboard/summary");
  return response.data;
};

export const getDashboardBatchPerformance = async () => {
  const apiClient = createApiClient();
  const response = await apiClient.get("/api/admin/dashboard/batch-performance");
  return response.data;
};

export const getDashboardTodayTasks = async () => {
  const apiClient = createApiClient();
  const response = await apiClient.get("/api/admin/dashboard/today-tasks");
  return response.data;
};
